import { MaytechService } from '../../_maytech/maytech.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpUtilsService, BaseModel } from '../../../core/_base/crud';
import { MaytechTenantService } from '../../_maytech/maytech.tenant.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../_reducers';
import { ObjectType, HttpAPICallType } from '../../_utils/define';
import { MaytechBaseAction } from '../../_maytech/maytech.actions';
import { CurrencyModel } from '../../../models/currency.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Real REST API
@Injectable()
export class CurrencyService extends MaytechService {
    constructor(http: HttpClient,
        httpUtils: HttpUtilsService,
        route: ActivatedRoute,
        public store: Store<AppState>,
        tenantService: MaytechTenantService ) {

        super(http, httpUtils, route,store, tenantService);

        if (tenantService.currentClient != null)
            this.API_URL = tenantService.currentClient.apiurl + '/currency';
    }

    getMainCurrency(): Observable<CurrencyModel> {
        const url = this.API_URL + `/GetMainCurrency/`;
        const httpHeaders = this.httpUtils.getHTTPHeaders();

        return this.http.get<CurrencyModel>(url, {
            headers: httpHeaders
        }).pipe(
            catchError(this.handleError("getMainCurrency", []))
        );
    }

    getBookingCurrency(bookingId: number): Observable<CurrencyModel> {
        const url = this.API_URL + `/getBookingCurrency/${bookingId}`;
        const httpHeaders = this.httpUtils.getHTTPHeaders();

        return this.http.get<CurrencyModel>(url, {
            headers: httpHeaders
        }).pipe(
            catchError(this.handleError("getBookingCurrency", []))
        );
    }

}
